<template>
  <div v-if="isOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 w-full h-full p-8">
    <div class="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative dark:bg-dark-box-bg dark:border dark:border-dark-border dark:text-dark-text max-h-[90vh] overflow-y-auto" @click.stop ref="modal" :style="modalStyle">
      <!-- <h2 class="text-xl font-bold mb-4 text-gray-800 dark:text-dark-text">Dodaj nowego Kierowcę</h2> -->
      <div 
        class="cursor-move mb-4 pb-2 border-b dark:border-dark-border"
        @mousedown="startDrag"
        @touchstart="startDrag"
      >
        <h2 class="text-2xl font-bold text-gray-800 dark:text-dark-text">Dodaj nowego Kierowcę</h2>
      </div>
      <button class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 focus:outline-none dark:text-dark-text dark:hover:text-dark-border-hover" @click="closeModal">
        <span class="text-xl">&times;</span>
      </button>
      <form @submit.prevent="submitCreate" class="space-y-4">
        <!-- Imię -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Imię <span class="text-red-600">(*)</span>:</label>
          <input v-model="localDriver.firstName" type="text" class="input-field w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text" :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.firstName }" @input="validateField('firstName')" />
          <span v-if="localErrors.firstName" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.firstName }}</span>
        </div>

        <!-- Nazwisko -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Nazwisko <span class="text-red-600">(*)</span>:</label>
          <input v-model="localDriver.lastName" type="text" class="input-field w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text" :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.lastName }" @input="validateField('lastName')" />
          <span v-if="localErrors.lastName" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.lastName }}</span>
        </div>

        <!-- Miasto -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Miasto <span class="text-red-600">(*)</span>:</label>
          <input v-model="localDriver.city" type="text" class="input-field w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text" :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.city }" @input="validateField('city')" />
          <span v-if="localErrors.city" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.city }}</span>
        </div>

        <!-- Telefon -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Telefon:</label>
          <input v-model="localDriver.phone" type="text" class="input-field w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text" :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.phone }" @input="validateField('phone')" />
          <span v-if="localErrors.phone" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.phone }}</span>
        </div>

        <!-- Samochód -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Samochód <span class="text-red-600">(*)</span>:</label>
          <input v-model="localDriver.car" type="text" class="input-field w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text" :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.car }" @input="validateField('car')" />
          <span v-if="localErrors.car" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.car }}</span>
        </div>

        <!-- Rok samochodu -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Rok samochodu <span class="text-red-600">(*)</span>:</label>
          <input v-model="localDriver.carYear" type="number" class="input-field w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text" :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.carYear }" @input="validateField('carYear')" />
          <span v-if="localErrors.carYear" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.carYear }}</span>
        </div>

        <!-- Numer rejestracyjny -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Numer rejestracyjny <span class="text-red-600">(*)</span>:</label>
          <input v-model="localDriver.registrationNumber" type="text" class="input-field w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text" :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.registrationNumber }" @input="validateField('registrationNumber')" />
          <span v-if="localErrors.registrationNumber" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.registrationNumber }}</span>
        </div>

        <!-- Adres Zamieszkania -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Adres zamieszkania <span class="text-red-600">(*)</span>:</label>
          <input v-model="localDriver.homeAddress" type="text" class="input-field w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text" :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.homeAddress }" @input="validateField('homeAddress')" />
          <span v-if="localErrors.homeAddress" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.homeAddress }}</span>
        </div>

        <!-- Status Kierowcy -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Status Kierowcy:</label>
          <select v-model="localDriver.driverStatus" class="input-field w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text">
            <option value="DOSTEPNY" class="text-dark-status-available dark:text-dark-status-available">Dostępny</option>
            <option value="NIEDOSTEPNY" class="text-dark-status-unavailable dark:text-dark-status-unavailable">Niedostępny</option>
            <option value="W_TRAKCIE" class="text-dark-status-pending dark:text-dark-status-pending">W Trakcie</option>
            <!-- <option value="ZAKONCZONY" class="text-dark-status-finished dark:text-dark-status-finished">Zakończony</option> -->
          </select>
        </div>

        <!-- Submit -->
        <button
            type="submit"
            :disabled="isFormInvalid"
            class="w-full bg-button-bg text-button-text py-2 rounded-md hover:bg-button-hover focus:outline-none focus:ring dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
            :class="{ 'opacity-50 cursor-not-allowed': isFormInvalid }"
        >
          Dodaj kierowcę
        </button>

      </form>
    </div>
  </div>
</template>

<style scoped>
/* Pasek przewijania w trybie ciemnym */
.dark .overflow-y-auto::-webkit-scrollbar {
  width: 8px; /* Szerokość paska przewijania */
}

.dark .overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #2c7a7a; /* Teal-700 */
  border-radius: 8px; /* Zaokrąglenie suwaka */
  border: 2px solid #1a5d5d; /* Ciemniejszy odcień teal dla krawędzi suwaka */
}

.dark .overflow-y-auto::-webkit-scrollbar-track {
  background-color: #333333; /* Ciemne tło dla śledzenia paska */
  border-radius: 8px; /* Zaokrąglenie tła paska */
}

/* Pasek przewijania w trybie jasnym */
.overflow-y-auto::-webkit-scrollbar {
  width: 8px; /* Szerokość paska przewijania */
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #d1d5db; /* Jasnoszary kolor suwaka (szary) */
  border-radius: 8px; /* Zaokrąglenie suwaka */
  border: 2px solid #9ca3af; /* Ciemniejszy szary dla krawędzi suwaka */
}

.overflow-y-auto::-webkit-scrollbar-track {
  background-color: #f3f4f6; /* Jasnoszare tło dla śledzenia paska */
  border-radius: 8px; /* Zaokrąglenie tła paska */
}

.cursor-move {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.dragging {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>

<script>
export default {
  props: {
    isOpen: Boolean,
  },
  data() {
    return {
      localDriver: {
        firstName: '',
        lastName: '',
        city: '',
        phone: '',
        car: '',
        carYear: '',
        registrationNumber: '',
        homeAddress: '',
        driverStatus: 'DOSTEPNY'
      },
      localErrors: {
        firstName: '',
        lastName: '',
        city: '',
        phone: '',
        car: '',
        carYear: '',
        registrationNumber: '',
        homeAddress: ''
      },
      isDragging: false,
      dragOffset: { x: 0, y: 0 },
      modalPosition: { x: 0, y: 0 }
    };
  },
  computed: {
    hasErrors() {
      return Object.values(this.localErrors).some(error => error !== '');
    },
    isFormComplete() {
    // Sprawdza, czy każde pole, poza driverStatus, jest uzupełnione
      return Object.entries(this.localDriver).every(([key, value]) => key === 'driverStatus' || value !== '');
    },
    isFormInvalid() {
      // Formularz jest niepoprawny, jeśli istnieją błędy lub brakuje wypełnionych pól
      return this.hasErrors;
    },
    modalStyle() {
      return {
        transform: `translate(${this.modalPosition.x}px, ${this.modalPosition.y}px)`
      };
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    validateField(field) {
      const driver = this.localDriver;
      switch (field) {
        case 'firstName':
          this.localErrors.firstName = driver.firstName.length < 2 ? 'Imię musi mieć co najmniej 2 znaki' : '';
          break;
        case 'lastName':
          this.localErrors.lastName = driver.lastName.length < 2 ? 'Nazwisko musi mieć co najmniej 2 znaki' : '';
          break;
        case 'city':
          this.localErrors.city = driver.city.length < 2 ? 'Miasto musi mieć co najmniej 2 znaki' : '';
          break;
        case 'phone':
          this.localErrors.phone = driver.phone.length < 9 ? 'Numer telefonu musi mieć min. 9 cyfr' : '';
          break;
        case 'car':
          this.localErrors.car = driver.car.length < 2 ? 'Nazwa samochodu musi mieć co najmniej 2 znaki' : '';
          break;
        case 'carYear': {
          const currentYear = new Date().getFullYear();
          this.localErrors.carYear = (driver.carYear < 1900 || driver.carYear > currentYear)
            ? `Rok samochodu musi być pomiędzy 1900 a ${currentYear}`
            : '';
          break;
        }
        case 'registrationNumber': {
            const regNumber = driver.registrationNumber;
            const isValidLength = regNumber.length >= 4;
            const isValidFormat = /^[A-Za-z0-9]+$/.test(regNumber);
            this.localErrors.registrationNumber = !isValidLength ? "Numer rejestracyjny musi mieć co najmniej 4 znaki" :
                                              !isValidFormat ? "Numer rejestracyjny może zawierać tylko litery i cyfry" : "";
            break;
        }
        case 'homeAddress':
          this.localErrors.homeAddress = driver.homeAddress.length < 2 ? "Adres zamieszkania musi mieć co najmniej 2 znaki" : "";
          break;
      }
    },
    submitCreate() {
      this.validateField('firstName');
      this.validateField('lastName');
      this.validateField('city');
      // this.validateField('phone');
      this.validateField('car');
      this.validateField('carYear');
      this.validateField('registrationNumber');
      this.validateField('homeAddress');

      if (!this.hasErrors) {
        this.$emit('submit', this.localDriver);

        this.localDriver = {
          firstName: '',
          lastName: '',
          city: '',
          phone: '',
          car: '',
          carYear: '',
          registrationNumber: '',
          homeAddress: '',
          driverStatus: 'DOSTEPNY'
        };

        this.localErrors = {
          firstName: '',
          lastName: '',
          city: '',
          phone: '',
          car: '',
          carYear: '',
          registrationNumber: '',
          homeAddress: ''
        };
      }
    },
    startDrag(event) {
        this.isDragging = true;
        
        event.currentTarget.classList.add('dragging');

        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        
        this.dragOffset.x = clientX - this.modalPosition.x;
        this.dragOffset.y = clientY - this.modalPosition.y;
        
        // Dodajemy event listeners
        document.addEventListener('mousemove', this.onDrag);
        document.addEventListener('touchmove', this.onDrag, { passive: false });
        document.addEventListener('mouseup', this.stopDrag);
        document.addEventListener('touchend', this.stopDrag);
      },
    onDrag(event) {
        if (!this.isDragging) return;
        
        event.preventDefault();
        
        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        
        this.modalPosition.x = clientX - this.dragOffset.x;
        this.modalPosition.y = clientY - this.dragOffset.y;
      },
    stopDrag() {
        this.isDragging = false;
        
        const dragElement = document.querySelector('.cursor-move');
        if (dragElement) {
          dragElement.classList.remove('dragging');
        }

        // Usuwamy event listeners
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('touchmove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
        document.removeEventListener('touchend', this.stopDrag);
      },
    resetPosition() {
        this.modalPosition = { x: 0, y: 0 };
    },
  }
};
</script>
